<mat-card [appLoading]="'login'">
  <mat-card-content>
    <img class="logo" src="../assets/img/logo-black.svg" alt="CDTSYS">
    <div id="g-signin"></div>
  </mat-card-content>
  <mat-card-footer>
    <p class="privacy-policy">Ao efetuar login, você concorda com nossa <a routerLink="/privacy-policy">Politica de Privacidade</a>.</p>
  </mat-card-footer>
</mat-card>
